import { render, staticRenderFns } from "./CannedResponse.vue?vue&type=template&id=1a8f68bc&"
import script from "./CannedResponse.vue?vue&type=script&lang=js&"
export * from "./CannedResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8f68bc')) {
      api.createRecord('1a8f68bc', component.options)
    } else {
      api.reload('1a8f68bc', component.options)
    }
    module.hot.accept("./CannedResponse.vue?vue&type=template&id=1a8f68bc&", function () {
      api.rerender('1a8f68bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/CannedResponse.vue"
export default component.exports